export default __webpack_public_path__ + "static/media/769.ee26f9ab.png";